import { AnalystApplicationCard } from '../components/AnalystApplicationCard';

export const AnalystApplication = () => {
  return <div>
    <AnalystApplicationCard />
  </div>
}